module.exports = __webpack_public_path__ + "img/san-lorenzo.4505d122.jpg";